<template>
  <element>
    <el-row>
      <el-col>
        <panel label="基本信息">
          <form-build
            :form-data="customerData"
            :form-columns="customerColumns"
            class="formTable"
          />
        </panel>
        <panel label="证件图片" class="zhengjianxinxi">
          <photo-browser v-model="customerData.pic__customerICFront" type='image' label="本人身份证正面"/>
          <photo-browser v-model="customerData.pic__customerICBack" type='image' label="本人身份证反面"/>
          <photo-browser v-model="customerData.pic__customerHukou1" type='image' label="本人户口本主页"/>
          <photo-browser v-model="customerData.pic__customerHukou2" type='image' label="本人户口本"/>
          <photo-browser v-model="customerData.pic__marriageCert" type='image' label="结婚证明"/>

          <photo-browser v-model="customerData.pic__spouseICFront" type='image' label="配偶身份证正面"/>
          <photo-browser v-model="customerData.pic__spouseICBack" type='image' label="配偶身份证反面"/>
          <photo-browser v-model="customerData.pic__divorceCert" type='image'label="离婚证"/>
          <photo-browser v-model="customerData.pic__singleCert" type='image' label="单身证明"/>

        </panel>

        <panel label="银行流水和征信证明等附件" class="zhengjianxinxi">
          <div class="zhenjianyyzz zhenjianyyzz2"> <file-upload  v-model="customerData.att__bankStatement" :editable="false" ></file-upload>借款人银行流水</div>
          <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerData.att__creditReport" :editable="false" ></file-upload>征信报告</div>
            <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerData.pic__marriageCertII" :editable="false" ></file-upload>婚档</div>
            <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerData.att__bizFile" :editable="false" ></file-upload>经营佐证</div>
            <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerData.att__miscFile" :editable="false" ></file-upload>其他资料</div>
        </panel>
        <panel label="评估信息">
          <form-build
            :form-data.sync="customerData"
            :form-columns="asmColumns"
            class="formTable"
          />
        </panel>
          <panel label="风控材料（包含房价、法务、一账通，产调等相关信息）" class="zhengjianxinxi">
              <div class="zhenjianyyzz zhenjianyyzz2"> <file-upload  v-model="customerData.asr__attachment1" :editable="false" ></file-upload></div>
          </panel>
      </el-col>
      <el-col>
      </el-col>
    </el-row>
  </element>
</template>

<script>
  import sexOptions from '../../utils/sexOptions'
  import {getImageUrl} from '../../filters/CommonActions'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Constant from "../../utils/constant";
  import DateTable from "../../components/DataTable";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "CustomerDetailComponent",
    components: {DateTable},
    data() {
      return {
        customerColumns: [
          {
            label: '身份证号码',
            field: 'ba__customerIC',

          },
          {
            label: '客户姓名',
            field: 'ba__customerName',

          },
          {
            label: '性别',
            field: 'ex__customerSex',
            formatter: function (c,v) {
              return Status2CN('Sex_'+v)
            }

          },


          {
            label: '手机号',
            field: 'ba__customerContactNo',
          },
          {
            label: '出生日期',
            field: 'ex__customerDOB',
            formatter: function (r,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },

          {
            label: '户口地区',
            field: 'ex__customerHukou',
          },

          {
            label: '籍贯',
            field: 'ex__customerJiguan',
          },
          {
            label: '常住地址',
            field: 'ex__customerAddress',

          },

          {
            label: '婚姻状况',
            field: 'ex__customerMartialStatus',

          },
            {
                label: '业务城市',
                field: 't__regionName',

            },

          {
            label: '配偶姓名',
            field: 'ex__spouseName',

          },
          {
            label: '配偶身份证号码',
            field: 'ex__spouseIC',

          },
          {
            label: '配偶手机',
            field: 'ex__spouseContactNo',

          },
            {
                label: '配偶户口',
                field: 'ex__spouseHukou',
            },
            {
                label: '配偶生日',
                field: 'ex__spouseDOB',
                formatter: function (r,v) {
                    if(v)
                        return moment(v).format('YYYY-MM-DD')
                }
            },

            {
                label: '配偶籍贯',
                field: 'ex__spouseJiguan',
            },
          {
            label: '申贷金额',
            field: 'ba__amount',
            formatter: function (c,v) {
              return formatMoney(v)
            },
            span:12
          },
          {
            label: '贷款产品',
            field: 'ba__productName',
          },
          {
            label: '贷款利率',
            field: 'interestType',
          },
          {
            label: '还款期数（月）',
            field: 'ba__repaymentCount',
          },

            {
                label: '行业类型',
                field: 'i2__name',
                formatter: function (r,v) {
                    return (r.i1__name?(r.i1__name):"")+(r.i2__name?("/"+r.i2__name):"")+(r.i3__name?("/"+r.i3__name):"")
                },
                span:24

            },

          {
            label: '贷款用途',
            field: 'ex__purpose',
            span:24
          },
          {
            label: '客户来源',
            field: 'ba__channel',
          },

          {
            label: '分配渠道商',
            field: 'd__dealerName'
          },
          {
            label: '进件人',
            field: 'jinjian__userName'
          },
          {
            label: '渠道商审核人员',
            field: 'chushen__userName',
          },
        ],
        columns:[
          {
            label: '序号',
            type: 'index'
          },
          {
            label: '查询渠道',
            field: 'pv__source',

          },{
            label: '挂牌单价',
            field: 'pv__quote',
            unit:'元/㎡'
          },

        ],
          asmColumns:[

              {
                  label: '核定贷款金额',
                  field: 'asr__approvedAmount',
                  formatter: function (c,v) {
                      return formatMoney(v)
                  },
                  unit:'元',
                  span:24
              },

              {
                  label: '其他资产情况',
                  field: 'asr__otherAssets',

                  span:24

              },
              {
                  label: '网络核查情况',
                  field: 'asr__internetCheck',

                  span:24

              },
              {
                  label: '评估情况',
                  field: 'asr__accessmentRemarks',
                  span:24

              },
              {
                  label: '结论',
                  field: 'asr__accessmentResult',
                  span:24

              },

          ],
      }
    },
    props: {
      value: {
        type: Object
      },
      isShowPic1: {
        Boolean,
        default: false
      }
    },
    computed: {
      customerData: {
        get: function () {
          return this.value
        },
        set: function (newVal) {
          this.$emit('input', newVal)
        }
      },
      numberAverage: function () {
        let arr = (this.customerData.values||[]).map(item=>item.pv__quote).filter(item=>item)
        return (arr.reduce(
          (total,curr)=> {
            total += Number(curr)||0
            return total
          }, 0
        ) / arr.length)||0
      }
    },
    filters: {
      getImageUrl,
      sex2CN: function (sex) {
        let sexItem = sexOptions.filter(item=>item.value==sex).shift()||[]
        return sexItem.label||''
      },
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerDetailFangComponent.vue